// Module
import { useLocation, Navigate } from "react-router-dom";

// Hooks
import { useAppSelector } from "app/hooks/hooks";
import { useAuthCheck } from "app/hooks/useAuthCheck";

// Redux
import { isLoggedInSelector } from "redux/userList/userSlice";

// Constant
import { Routes } from "constants/global";

type RouteGuardProps = {
	children: JSX.Element;
};

const useRouteGuard = () => {
	const location = useLocation();
	const isUserLoggedIn = useAppSelector(isLoggedInSelector);

	useAuthCheck();

	return {
		isUserLoggedIn,
		pathname: location?.pathname
	};
};

const RouteGuard = ({ children }: RouteGuardProps) => {
	const { isUserLoggedIn, pathname } = useRouteGuard();

	return isUserLoggedIn ? children : <Navigate to={Routes.LOGIN} replace state={{ path: pathname }} />;
};

export default RouteGuard;
